import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListMessanger } from '../store/thunk/setGetListMessanger';
import { useRouter } from '../../../../@casino/useRouter';
import Table from '../../../../@casino/ui/table';

const Messanger = () => {
    const dispatch = useDispatch();
    const router = useRouter()

    React.useEffect(() => {
        dispatch(setGetListMessanger())
    }, [])

    const list = useSelector(state => state.messanger.list);
    const columns = [
        { id: 'type', label: 'Тип'},
        { id: 'link', label: 'Ссылка'},
        { id: 'language', label: 'Язык для отображения'},
        { id: 'change', label: ''},
    ];


    const rows = list.map((item) => {
        return {
            type: item.type,
            link: item.link,
            language: item?.language,
            change: <span style={{cursor: 'pointer'}} onClick={() => router.history.push(`/settings/messanger/edit/${item.id}`)}>Изменить</span>
        }
    })

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Мессенджеры" 
                labelBtn="Добавить"
                button={() => {
                    router.history.push('/settings/messanger/create')
                }}
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                width: '100%', 
            }}>
                <Table
                    columns={columns}
                    rows={rows}
                />
            </div>
        </div>
    )
}

export default Messanger;